<template>
    <a :href="post.link">
        <img class="post__image" v-if="post._embedded['wp:featuredmedia'][0]" :src="getPostImage(post)">
        <div class="post-content">
          <h2 class="post__title" v-html="post.title.rendered"></h2>
          <div class="post__meta">
              {{ post._embedded.author[0].name }} {{ formattedDate(post.date) }}
          </div>
        </div>
    </a>
</template>

<script>
import moment from 'moment';

export default {
  name: 'WordsOfWisdomPost',
  data() {
    return {
    }
  },
  props: [
    'post'
  ],
  methods: {
    formattedDate(date) {
      return moment(date).format("D/M/Y")
    },
    getPostImage(post) {
      console.warn(post)
      if(post._embedded['wp:featuredmedia'][0]['media_details']['sizes']['large']) {
        return post._embedded['wp:featuredmedia'][0]['media_details']['sizes']['large'].source_url
      }
      return post._embedded['wp:featuredmedia'][0]['media_details']['sizes']['full'].source_url
    }
  }
}
</script>

<style lang="scss">
.posts span {
  display: flex;
  flex-wrap: wrap;
}
.post:hover .post__image {
    filter: brightness(0.5);
    /* opacity: 1; */
    transition: all 0.3s ease-in-out;
}

.post a {
    text-decoration: none;
    color: inherit;
}
.post {
  text-align: left;
  flex-basis: 100%;
  font-family: "Circular std book", sans-serif;
  position: relative;
  
  @media screen and (min-width: 640px) {
    flex-basis: 25%;
  }
}
.post:first-of-type {
  flex-basis: 100%;

  @media screen and (min-width: 640px) {
    flex-basis: 50%;
  }
}
.post-content {
  padding: 2em 2em 4em 2em;
}
.post .post__image {
  width: 100%;
  height: 50vw;
  object-fit: cover;

  @media screen and (min-width: 640px) {
    height: 40vw;
  }
  @media screen and (min-width: 1024px) {
    height: 500px;
  }
}
.post .post__title {
  font-size: 23px;
  margin-top: 0;
  margin-bottom: 0.25em;
  color: black;
  font-family: "Circular std book", sans-serif;
}
.post .post__meta {
  color: #767676;
  font-family: "Circular std book", sans-serif;
}
</style>
